import React from 'react'
import StaffManagement from '../components/staffManagement/StaffManagement'
import { hasPermission } from '../components/auth/login/Login';

const StaffManagementPage = () => {

    const canManageStaff = hasPermission("Staff Management", "Staff", "read");

    if (!canManageStaff) {
        window.location.href = '/no-permission';
    }

    return (
        <div className='outletConainer'>
            <StaffManagement />
        </div>
    )
}

export default StaffManagementPage
